import { reportToMarketo } from '../api.client';
import { getGaClientId } from '../gtm';

export type MarketoLeadEmail = {
	email: string;
};

export type MarketoLeadActivityData = {
	email: string;
	wixAnswersUrl: string;
	personLanguage: string;
	freeTrialPhoneNumber?: string;
};

export type MarketoLeadId = {
	id: number;
};

export type MarketoHttpHeaders = {
	Authorization: string;
	'Content-Type': string;
};

export type MarketoNewLeadData = {
	userEmail: string;
	userName: string;
	organizationName: string;
	subdomain?: string;
	uid?: string;
	tenantId?: string;
};

export type MarketoLeadData = {
	firstName: string;
	lastName: string;
	email: string;
	company: string;
	cookie?: string;
	Tenant_URL__c?: string;
	Tenant_ID__c?: string;
	wa_uuid?: string;
	Conversion_Page_URL__c?: string;
	gacid?: string;
	most_Recent_Referral_URL?: string;
	UTM_Campaign__c?: string;
	UTM_Content__c?: string;
	UTM_Medium__c?: string;
	UTM_Source__c?: string;
	UTM_Term__c?: string;
	UTM_Campaign_ID?: string;
	utm_partner_src?: string;
	visitorClientID?: string;
	Free_Trial_Account__c?: boolean;
	Free_Trial_Account_Created__c?: string;
};

export type MarketoUtms = {
	UTM_Campaign__c?: string;
	UTM_Content__c?: string;
	UTM_Medium__c?: string;
	UTM_Source__c?: string;
	UTM_Term__c?: string;
	UTM_Campaign_ID?: string;
	utm_partner_src?: string;
};

export type MarketingParams = {
	fullPageUrl?: string;
	gacid?: string;
	most_Recent_Referral_URL?: string;
	utms: MarketoUtms;
};

const addAdditionalAccountData = () => {
	const newDate = new Date();
	const accountDateTime = newDate.toJSON();
	return {
		Free_Trial_Account__c: true,
		Free_Trial_Account_Created__c: accountDateTime || ''
	};
};

const checkForCookie = (val: string = '_mkto_trk') => {
	const availableCookies = document.cookie;
	const availableCookiesArr = availableCookies.split(';');
	const isAvailableCookie = availableCookiesArr.some((item) => item.includes(val));
	if (isAvailableCookie) {
		const MktCookie = availableCookiesArr.find((cookie) => cookie.includes(val));
		const MktCookieValue = MktCookie ? MktCookie.split('=')[1] : '';
		return MktCookieValue;
	} else {
		return undefined;
	}
};

export const checkForMktoUtms = (): MarketoUtms => {
	const url = new URL(document.location.href);
	const params = new URLSearchParams(url.search);
	const mktoUtmObj = {
		last_Form_Conversion_Type: 'Free Trial',
		UTM_Campaign__c: params.get('utm_campaign') || '',
		UTM_Content__c: params.get('utm_content') || '',
		UTM_Medium__c: params.get('utm_medium') || '',
		UTM_Source__c: params.get('utm_source') || '',
		UTM_Term__c: params.get('utm_term') || '',
		UTM_Campaign_ID: params.get('utm_campaign_id') || '',
		utm_partner_src: params.get('utm_partner_src') || ''
	};

	return mktoUtmObj;
};

const getMostRecentReferralURL = () => {
	if (checkForCookie('wamk_most_recent_ref')) {
		return checkForCookie('wamk_most_recent_ref');
	} else if (checkForCookie('_uc_last_referrer')) {
		return checkForCookie('_uc_last_referrer');
	} else {
		return;
	}
};

export const updateMkto = async (newLead: MarketoNewLeadData) => {
	const fullPageUrl = document.location.href;
	const utms = checkForMktoUtms();
	const cookieObj = checkForCookie('_mkto_trk') ? { cookie: checkForCookie('_mkto_trk') } : {};
	const gaClientId = getGaClientId();
	const mostRecentRef = getMostRecentReferralURL();
	const additionalData = addAdditionalAccountData();
	const lead = {
		firstName: newLead.userName.split(' ')[0] || '',
		lastName: newLead.userName.split(' ')[1] || '',
		email: newLead.userEmail,
		company: newLead.organizationName,
		Tenant_URL__c: newLead.subdomain + '.wixanswers.com' || '',
		wa_uuid: newLead.uid || '',
		Tenant_ID__c: newLead.tenantId || '',
		Conversion_Page_URL__c: fullPageUrl || '',
		gacid: gaClientId || '',
		most_Recent_Referral_URL: mostRecentRef || '',
		...utms,
		...cookieObj,
		...additionalData
	};

	try {
		const res = await reportToMarketo(lead);
		return res;
	} catch (err) {
		// tslint:disable-next-line: no-console
		console.error('Error updating Marketo: ', err);
	}
};

export const getMarketingParams = (): MarketingParams => {
	const fullPageUrl = document.location.href;
	const utms = checkForMktoUtms();
	const gacid = getGaClientId();
	return {
		utms,
		gacid,
		fullPageUrl
	};
};
